import { getApiUrl } from '../config/config';

class FollowService {
  async followCreator(creatorId) {
    const token = localStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/follow/${creatorId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to follow creator');
    return await response.json();
  }

  async unfollowCreator(creatorId) {
    const token = localStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/follow/${creatorId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to unfollow creator');
    return await response.json();
  }

  async getFollowStatus(creatorId) {
    const token = localStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/follow/status/${creatorId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to get follow status');
    return await response.json();
  }

  async getFollowingList() {
    const token = localStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/follow/following`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to get following list');
    return await response.json();
  }

  async getFollowersList(creatorId) {
    const response = await fetch(`${getApiUrl()}/follow/followers/${creatorId}`, {
      headers: { 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error('Failed to get followers list');
    return await response.json();
  }
}

class FeedService {
  async getFeed(page = 1, limit = 20) {
    const token = localStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/feed?page=${page}&limit=${limit}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to get feed');
    return await response.json();
  }

  async getTrendingPosts(limit = 10) {
    const response = await fetch(`${getApiUrl()}/feed/trending?limit=${limit}`);
    if (!response.ok) throw new Error('Failed to get trending posts');
    return await response.json();
  }

  async likePost(postId) {
    return this.updateLike(postId, 'POST');
  }

  async unlikePost(postId) {
    return this.updateLike(postId, 'DELETE');
  }

  async updateLike(postId, method) {
    const token = localStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/feed/like/${postId}`, {
      method,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to update like');
    return data;
  }
}

const followService = new FollowService();
const feedService = new FeedService();

export { followService, feedService };
export default { followService, feedService };
